export default __webpack_public_path__ + "static/media/fachada-desktop.0ad0010a.jpg";